import { useEffect } from "react";

/**
 * Warn on browser tab close / hard nav when there are unsaved changes.
 * React Router in-app nav is handled separately (see EditRole page).
 */
export const useBeforeUnload = (enabled: boolean, message = "You have unsaved changes.") => {
  useEffect(() => {
    if (!enabled) return;
    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = message;
      return message;
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [enabled, message]);
};

export default useBeforeUnload;
